import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { MouldingProcessService } from './api/mouldingProcess.service';
import { MouldsService } from './api/moulds.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class MouldingProcessApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MouldingProcessApiModule> {
        return {
            ngModule: MouldingProcessApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: MouldingProcessApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('MouldingProcessApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
